export enum IFrameMessageTypes {
  TaxonomyCatalogUrlPath = 'TaxonomyCatalogUrlPath',
  TaxonomyCatalogKibanna = 'TaxonomyCatalogKibanna',
  DataDictionaryUrlPath = 'DataDictionaryUrlPath',
  TaxonomyCatalogFeatureFlags = 'TaxonomyCatalogFeatureFlags',
  TaxonomyCatalogBrand = 'TaxonomyCatalogBrand',
  TaxonomyCatalogTheme = 'TaxonomyCatalogTheme',
  DataDictionaryTheme = 'DataDictionaryTheme',
}

/** Resolved colour mode the dashboard hands to an embedded site. */
export type MethodologyTheme = 'light' | 'dark';

/** Query param every iframed site reads on first paint. */
export const METHODOLOGY_THEME_PARAM = 'theme';

export const isMethodologyTheme = (value: unknown): value is MethodologyTheme =>
  value === 'light' || value === 'dark';

export const WILSON_CLIENT_NAMES = new Set([
  'Wilson HR',
  'Wilson HCG',
  'Wilson_SuperUsers',
]);
